import { CompletedAnswerData } from "../types/checkInTypes";

export const getSortedAnswers = (answers?: CompletedAnswerData[]) =>
  answers?.toSorted(
    (questionA, questionB) =>
      (questionA.question?.order ?? 0) - (questionB.question?.order ?? 0),
  );
